import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type IntercomLauncherVisibilityValue = {
  /** När true döljs Intercoms standardlauncherknapp (Fin AI) via API */
  suppressIntercomLauncher: boolean;
  setSuppressIntercomLauncher: (suppress: boolean) => void;
};

const IntercomLauncherVisibilityContext = createContext<IntercomLauncherVisibilityValue>({
  suppressIntercomLauncher: false,
  setSuppressIntercomLauncher: () => {},
});

export function IntercomLauncherVisibilityProvider({ children }: { children: ReactNode }) {
  const [suppressIntercomLauncher, setSuppress] = useState(false);
  const setSuppressIntercomLauncher = useCallback((suppress: boolean) => {
    setSuppress(suppress);
  }, []);

  const value = useMemo(
    () => ({ suppressIntercomLauncher, setSuppressIntercomLauncher }),
    [suppressIntercomLauncher, setSuppressIntercomLauncher]
  );

  return (
    <IntercomLauncherVisibilityContext.Provider value={value}>
      {children}
    </IntercomLauncherVisibilityContext.Provider>
  );
}

export function useIntercomLauncherVisibility() {
  return useContext(IntercomLauncherVisibilityContext);
}
